import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { superAdminService } from '../services/super-admin.service';
import type { UpdateSuperAdminRequest, SuperAdmin } from '../types/super-admin.types';

interface UpdateSuperAdminParams {
  userId: string;
  data: UpdateSuperAdminRequest;
}

export function useUpdateSuperAdmin(): {
  updateSuperAdmin: UseMutateFunction<SuperAdmin, Error, UpdateSuperAdminParams>;
  updateSuperAdminAsync: (params: UpdateSuperAdminParams) => Promise<unknown>;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  reset: () => void;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ userId, data }: UpdateSuperAdminParams) =>
      superAdminService.updateSuperAdmin(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['super-admins'] });
    },
  });

  return {
    updateSuperAdmin: mutation.mutate,
    updateSuperAdminAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
